export const MX_EVENTS = {
  CONNECTED: 'connected',
  CONNECTING: 'connecting',
  SEARCH: 'search'
}

export const MX_TYPE = {
  DISCONNECTED: 'mx/connect/memberDeleted',
  DISCONNECT_INITIATED: 'mx/focusTrap',
  MEMBER_CONNECTED: 'mx/connect/memberConnected',
  SELECTED_INSTITUTION: 'mx/connect/selectedInstitution',
  STEP_CHANGE: 'mx/connect/stepChange'
}
